export default "__VITE_ASSET__BIrb8hGc__"